module.exports = __webpack_public_path__ + "img/home.84885eae.png";